import { writable } from 'svelte/store';

import user_language_options from "./interface/user_language_options.json"

// declare empty object to store user responses
export const responses = writable(
    {
    }
)

// store user language in localStorage
// (inspired by https://dev.to/danawoodman/svelte-quick-tip-connect-a-store-to-local-storage-4idi)
const available_languages = Object.keys(user_language_options)
let user_language_from_url = ""
const user_language_stored = localStorage.getItem("user_language")
let user_language_inferred_from_browser = ""

// if language passed in URL
let params = new URLSearchParams(window.location.search);
if (params.get("lang") && available_languages.includes(params.get("lang"))) {
    user_language_from_url = params.get("lang")
}

// attempt to set language based on browser preference
let browser_lang = navigator.language.toUpperCase()

// try for an exact match
if (available_languages.includes(browser_lang)) {
    user_language_inferred_from_browser = browser_lang
} else {
    // search for a match of the first two characters of language string
    available_languages.forEach((lang) => {
        if (browser_lang.substring(0, 2) === lang.substring(0, 2)) {
            user_language_inferred_from_browser = lang
        }
    })
}

// set the language; order of precedence is: explicit declaration in URL > localStorage > browser settings > default
export const user_language = writable(user_language_from_url || user_language_stored || user_language_inferred_from_browser || "EN")

user_language.subscribe((value) => localStorage.setItem('user_language', value))